interface GenderData {
  id?: number;
  name?: string;
}


export class Gender {
  public static readonly ID_MALE: number = 1;
  public static readonly ID_FEMALE: number = 2;

  public static readonly ID_DEFAULT: number = Gender.ID_MALE;

  public static getNonTranslatableFields(): string[] { return ['id']; }
  public static getTranslatableFields(): string[] { return ['name']; }
  public static getFields(): string[] { return ['id', 'name']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  name?: string;

  public static fromAPI(data: GenderData): Gender {
    return new Gender(data);
  }

  public static fromAPIList(data: GenderData[]): Gender[] {
    return data.map((item: GenderData) => Gender.fromAPI(item));
  }


  constructor({id, name} : GenderData) {
    this.id = id;
    this.name = name;
  }

  public toJson(): Object {
    return {
      id: this.id,
      name: this.name
    };
  }

}
